module.exports = __webpack_public_path__ + "img/the-netherlands-digestive-diseases-female.eb08867b.png";